import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionResult } from 'src/app/core/services/interfaces/transaction-result';
import { NotificationService } from 'src/app/core/services/notification/notification.service';
import { TranslateApplicationService } from 'src/app/core/translate/translate-application-service';
import { ISitesConfigurations } from '../../Interfaces/ISitesConfigurations';
import { SitesService } from '../../services/sites-services';
import { TypeValuesService } from '../../services/typevalues-service';
declare var jQuery: any;

@Component({
  selector: 'app-sites-configurations-details',
  templateUrl: './sites-configurations-details.component.html',
  styles: [
  ]
})
export class SitesConfigurationsDetailsComponent implements OnInit {

  formGroup: FormGroup;
  loading = false;
  listValue: Array<ISitesConfigurations> = []
  constructor(
    private dialogRef: MatDialogRef<SitesConfigurationsDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ISitesConfigurations,
		private notificationService: NotificationService,
		private SiteService: SitesService,
		private formBuilder: FormBuilder,
    public translate: TranslateApplicationService,
  ) {
    this.formGroup = this.formBuilder.group({
      pksiteconfiguration: [data.pksiteconfiguration == null ? 0: data.pksiteconfiguration, Validators.required],
      txtconfiguration: [data.configuration == null ? "" : data.configuration, Validators.required],
      txtdescription: [data.description == null ? "" : data.description, Validators.required],
      cbvalue: [data.value, Validators.required],
      cbpksiteconfigurationvalue: ['']
    });
  }

  ngOnInit(): void {
    this.GetValues();
  }

  Alert() {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Success',
			message: this.translate.TranslateKey('COMPLETE'),
			shown: true,
		});
	}

  Save() {
    this.loading = true;
    if (this.formGroup.valid) {
      this.SiteService.UpdateSiteConfiguration(this.formGroup.value).subscribe(
      (result: TransactionResult<boolean>) => {
        this.loading = false;
        if (result.success) {
          this.Alert();
          this.Close();
        }
        else{
          this.ErrorAlert(result.message);
        }
      },
      (error) => {
        this.ErrorAlert(error);
        this.loading = false;
      });
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }

  GetValues() {
    this.loading = true;
    this.SiteService.GetValuesBySitesConfigurations(this.data.configuration).subscribe(
    (result: TransactionResult<ISitesConfigurations[]>) => {
      this.loading = false;
      if (result.success) {
        this.listValue = result.data;
      }
      else{
        this.ErrorAlert(result.message);
      }
    },
    (error) => {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }

  Close() {
    this.dialogRef.close(true);
  }

  ErrorAlert(message: any) {
		this.notificationService.AddAlert({
			icon: 'all_inbox',
			title: 'Error',
			message: message,
			shown: true,
		});
 	}
}
